import { DocumentNode, gql } from '@apollo/client';
import { Text, TextProps } from '@chakra-ui/layout';
import * as React from 'react';

import { EventAudience_EventFragment } from './graphql-types/EventAudience_EventFragment';

import { EventAudienceGroupName } from './components/EventAudienceGroupName';
import { EventAudienceLink } from './components/EventAudienceLink';

export const EventAudience: React.FC<
  {
    event: EventAudience_EventFragment;
    isAdminRoute?: boolean;
  } & TextProps
> & {
  eventFragment: DocumentNode;
} = ({ event, isAdminRoute, ...props }) => {
  const hostOrganization =
    (event.__typename === 'SimpleEventV2' && event.hostOrganization) ||
    undefined;

  const groupIds = event.visibility.groupIds ? event.visibility.groupIds : [];

  if (hostOrganization) {
    return (
      <Text {...props}>
        Hosted by{' '}
        <EventAudienceLink
          to={
            isAdminRoute
              ? `/admin/companies/${hostOrganization._id}/details`
              : `/companies/${hostOrganization._id}`
          }
        >
          {hostOrganization.displayName}
        </EventAudienceLink>
      </Text>
    );
  }

  if (groupIds.length) {
    return (
      <Text {...props}>
        Hosted in{' '}
        {groupIds.map((groupId, index) => (
          <React.Fragment key={groupId}>
            {index !== 0 && ', '}
            <EventAudienceGroupName
              groupId={groupId}
              isAdminRoute={isAdminRoute}
            />
          </React.Fragment>
        ))}
      </Text>
    );
  }

  return null;
};

EventAudience.eventFragment = gql`
  fragment EventAudience_EventFragment on EventV2 {
    _id
    visibility {
      type
      groupIds
    }
    ... on SimpleEventV2 {
      _id
      hostOrganization {
        _id
        displayName
      }
    }
  }
`;
